import Parse, { User } from 'parse'
import moment from 'moment-timezone'
import { param } from 'jquery';

moment.tz.setDefault('America/Mexico_City');

class WishList extends Parse.Object {
  constructor() {
    super('WishList');
  }

  get fullAddress () {
    return `${this.get('street')} ${this.get('suburb')} ${this.get('interior')}`
  } 

  get createdAt () {
    return this.get('createdAt')
  }
  
  get players () {
    return this.get('players')
  }

  get name () {
    return this.get('name')
  }

  get user () {
    return this.get('user')
  }

  /*static saveList(params){
  
    const list = new WishList()
    
    list.set('name', params.name)
    list.set('user', params.user) 
  
    return list.save()

  }*/


  //-- Load Info
  static loadForList (limit = 2000, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      .include('Players')
      .find()
  }
  
  static getList() {
    return Parse.Cloud.run('userLists')
  }

  static playersLists() {
    return Parse.Cloud.run('playersOfList')
  }
  
  static removePlayerList(params) {
    return Parse.Cloud.run('removePlayerList', params)
  }

  static addPlayerToList(param) {
    
    const params = {
      nameList: param.nameList,
      playerId: param.id
    }

    return Parse.Cloud.run('addPlayerToList', params)
  }

  static saveList(params) {
    return Parse.Cloud.run('addPlayerToList', params)
  }

  static saveListJust(params){
    return Parse.Cloud.run('createList', params)
  }
  
  static playersListsFilter(params){
    return Parse.Cloud.run('playersOfList', params)
  }
  
  dump () {
    console.log(this)
  }
}

export default WishList
